/**
 * Observes an object for changes and sends change notifications during the browser's paint cycle.
 * @returns {{}}
 * @constructor
 */
export function PaintTimer (state) {
  // Timer Status
  let isRunning = false;
  let callback;

  /**
     * Starts monitoring the watched object for changes and calls the callback along animationFrame edges
     * @param changeDelegate
     */
  this.start = (changeDelegate) => {
    callback = changeDelegate;
    isRunning = true;
    mainLoop();
  };

  /**
     * Stops notifying the change delegate of changes.
     */
  this.stop = () => {
    isRunning = false;
  };

  // Checks for changes and calls the callback if any exist, then recursively calls itself.
  function mainLoop () {
    if (state.hasChanges) {
      callback(state, state.changes);
      state.clearChanges();
    }
    if (!isRunning) {
      return;
    }
    requestAnimationFrame(mainLoop);
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/services/rendering/PaintTimer.js